var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.25C24 18.8774 18.6274 24.25 12 24.25C5.37258 24.25 0 18.8774 0 12.25C0 5.62258 5.37258 0.25 12 0.25C18.6274 0.25 24 5.62258 24 12.25ZM9.6927 19.8764C9.62376 19.8333 9.5586 19.7818 9.49866 19.7219C9.07264 19.2959 9.07264 18.6052 9.49866 18.1791L14.2556 13.4222C15.0366 12.6412 15.0366 11.3748 14.2556 10.5938L9.49866 5.8369C9.07264 5.41087 9.07264 4.72014 9.49866 4.29412C9.92469 3.86809 10.6154 3.86809 11.0414 4.29412L11.145 4.39766C11.2048 4.43731 11.2615 4.48348 11.3142 4.53616L17.6138 10.8358C18.3949 11.6169 18.3949 12.8832 17.6138 13.6643L11.3142 19.9639C10.8881 20.39 10.1974 20.39 9.77139 19.9639C9.74331 19.9359 9.71708 19.9066 9.6927 19.8764Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.1956fdbe7f6bb7d7c9db5a2a7ca53819.svg";
export { ForwardRef as ReactComponent };